// Set Webpack's public path so lazy-loaded bundles are grabbed from the correct location.
// For production builds, hashed assets are at the CDN root level (shared across versions).
// For private deploys, hashed assets are in the versioned branch directory.
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

const hostingConfig = readHostingConfiguration();

// scriptBaseUrl always points to the versioned directory (for both production and private deploy)
const versionedPath = hostingConfig.scriptBaseUrl || '/';

// Preserve the versioned deploy path for translation files and other non-webpack assets
window.__yammer_versioned_deploy_path__ = versionedPath;

// In private deploy mode, ALL assets (hashed and non-hashed) are in the branch directory
// In production, hashed assets are optimized at CDN root level (shared across versions for better caching)
const isPrivateDeploy = process.env.ENABLE_BROWSER_SUPPORT === 'true';

__webpack_public_path__ = isPrivateDeploy ? versionedPath : hostingConfig.cdnBaseUrl || '/';
